<template>
    <div class="flats-crm-section active" v-if="salesCard != null && flatsPage != null" :class="{'inViewCheck' : inViewCheck}">
        <flatsFilterMobile v-if="isMobileChecker"></flatsFilterMobile>
        <div class="container">
            <div class="land-section-title">
                <div class="section-title">
                    <h2>{{salesCard.project_shablon_fields.flats_plans_title}}</h2>
                </div>
                <flatsBtns v-if="!isMobileChecker"></flatsBtns>
            </div>
            <flatsTopBar v-if="isMobileChecker" id="flatsTopBar"></flatsTopBar>
            <flatsFilterDesctop v-if="salesCard != null && !isMobileChecker"></flatsFilterDesctop>
            <transition name="fade" mode="out-in">
		        <flatsItemsGrid v-if="gridView"></flatsItemsGrid>
                <flatsItemsList v-else :mobileView="isMobileChecker"></flatsItemsList>
            </transition>
            <flatsModal :mobileView="isMobileChecker"></flatsModal>
            <div class="pagination-btns" v-if="flatsItems != null && flatsPagintaion.remainingApartments != 0">
                <a href="#" @click.prevent="getMoreFlats">
                    <span v-if="globalLang != 'kz/'">Загрузить ещё</span> 
                    <span v-else>Тағы жүктеу</span>
                    {{flatsPagintaion.remainingApartments}}
                </a>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
	import flatsFilterDesctop from '@/components/flats-crm/flats-crm-filter-desctop.vue'
	import flatsItemsGrid from '@/components/flats-crm/flats-crm-items.vue'
	import flatsItemsList from '@/components/flats-crm/flats-crm-items-list.vue'
	import flatsBtns from '@/components/flats-crm/flats-crm-btns.vue'
	import flatsModal from '@/components/flats-crm/flats-crm-modal.vue'
    // mobile
	import flatsTopBar from '@/components/flats-crm/flats-crm-topbar-mobile.vue'
	import flatsFilterMobile from '@/components/flats-crm/flats-crm-filter-mobile.vue'

    export default {
        name: 'sale-land-flats',
        components: {
			flatsFilterDesctop,
            flatsItemsGrid,
            flatsItemsList,
            flatsBtns,
            flatsModal,
            flatsTopBar,
            flatsFilterMobile,
			// flatsCards,
        },
        data () {
            return {
                inViewCheck: false,
                slicky: false,
                topOffetBar: 0,
                minusNum: 50,
                globalLang: window.GlobalLang, 
                // for flats filter
            }
        },
        computed: mapGetters({
            flatsPage: 'loadSalesFlatsPageData',
            salesCard: 'loadSalesCardContent',
            salesCardFlats: 'loadFlatsCardsGlobal',
            salesCardFlatsDefault: 'loadFlatsCardsGlobalDefault',
            saleItem: 'loadSaleCardItem',
            saleFilterParams: 'loadSalesFilterCardParams',
            flatsFilterData: 'loadFlatsFilterData',
            paginPageNumber: 'loadPaginPageNumber',
			gridView: 'loadLandFlatsGridView',
            flatsItems: 'loadFlatsItems',
            flatsPagintaion: 'loadFlatsPagination',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
            hidePaginBtn: 'loadHidePaginBtn',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getMoreFlats() {
                const count = this.paginPageNumber + 1;
                this.$store.commit('UpdatePaginPageNumber', count);
                this.flatsFilterData.pageNumber = this.paginPageNumber;
                this.$store.dispatch('getFlatsByPagination', this.flatsFilterData);
                this.$store.dispatch('getFlatsPagintationCounters', this.flatsFilterData);
            },
        },
        mounted () {
            if (window.host != 'landmark') {
                this.$store.dispatch('getFlatsItems', {
                    "complexCodes": [this.saleFilterParams.crm_code],
                    "linesOnPage": 8
                }).then((response) => {
                    this.$store.dispatch('getFlatsPagintationCounters', {
                        "complexCodes": [this.saleFilterParams.crm_code],
                        "linesOnPage": 8
                    });
                });
            } else {
                this.$store.dispatch('getFlatsItems', {
                    "complexCodes": ['LDM', 'LDM-II', 'LDM-III', 'LDM-IV'],
                    "linesOnPage": 8
                }).then((response) => {
                    this.$store.dispatch('getFlatsPagintationCounters', {
                        "complexCodes": ['LDM', 'LDM-II', 'LDM-III', 'LDM-IV'],
                        "linesOnPage": 8
                    });
                });
            }
           
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-section.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-section-respond.scss';
</style>